export const API_END_POINT = {
  CREATE_USER: "/auth/register",
  CHAT_BOT:"/api/chat",
  CONTACT_US:"/contact",
  START_SERVER:"/api/test"
};
